import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query'
import { Provider } from 'react-redux';
import App from './App';
import SessionTimeout from './utils/sessionTimeout';
import {store} from "./rdx/store";
import reportWebVitals from './reportWebVitals';
import "./index.scss";
import "./elsa-style.scss";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const queryClient = new QueryClient();
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <App />
        {/* Proactively refresh tokens before expiry instead of blocking active users */}
        <SessionTimeout />
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
